import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-secondary text-white text-center pt-3 pb-3">
    <p>Tomoki Hosoya's Port Folio</p>
    </footer>
  )
}

export default Footer
